import { edgeFehlerText } from '@finavest/shared/client';
import { ENDPOINTS } from './config';
import type { LeadPayload, BeratungPayload } from './types';

export class ApiError extends Error {
  constructor(
    message: string,
    readonly status?: number,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

async function postJson<T>(url: string, body: unknown): Promise<T> {
  let res: Response;
  try {
    res = await fetch(url, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(body),
    });
  } catch {
    throw new ApiError('Verbindung fehlgeschlagen. Bitte versuchen Sie es erneut.');
  }
  if (!res.ok) {
    throw new ApiError(await fehlerText(res), res.status);
  }
  return (await res.json()) as T;
}

/** The worker's `{ error }` code on a 4xx, or null (no body / not JSON). */
async function errorCode(res: Response): Promise<string | null> {
  try {
    const body = (await res.json()) as { error?: unknown };
    return typeof body.error === 'string' ? body.error : null;
  } catch {
    return null;
  }
}

/**
 * Klartext per edge verdict. The two A6 codes come from `@finavest/shared`
 * (one table for every widget on `/api/*` — MINOR-N1 uit de #491-hermeting);
 * the generic wording stays LOCAL and mentions the captcha, because this
 * form has no OTP leg to point at.
 */
async function fehlerText(res: Response): Promise<string> {
  const geteilt = edgeFehlerText(res.status, await errorCode(res));
  if (geteilt) return geteilt;
  return res.status === 400 || res.status === 403
    ? 'Bitte prüfen Sie Ihre Eingaben und die Bestätigung (kein Roboter).'
    : 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.';
}

export function submitLead(payload: LeadPayload): Promise<{ leadId: string }> {
  return postJson<{ leadId: string }>(ENDPOINTS.lead, payload);
}

export function submitBeratung(payload: BeratungPayload): Promise<{ ok: boolean }> {
  return postJson<{ ok: boolean }>(ENDPOINTS.beratung, payload);
}
